module.exports = __webpack_public_path__ + "img/A.0459eff6.webp";